import React from "react";
import { SentryReporterInterface } from "../..";

export const SentryReporterContext =
  React.createContext<SentryReporterInterface | null>(null);

export const useSentryReporter = () => {
  const reporter = React.useContext(SentryReporterContext);
  if (!reporter) {
    throw new Error(
      "useSentryReporter must be used within a SentryReporterProvider"
    );
  }
  return reporter;
};
